import { apiInstance } from "./api"

const endpoint = "/wallet"

export const getServiceOwnerWallet = async () => {
  const { dhFoods } = apiInstance()

  const response = await dhFoods.get(`${endpoint}/serviceOwner`)

  return response.data
}

export const getBalanceReport = async () => {
  const { dhFoods } = apiInstance()

  const response = await dhFoods.get(`${endpoint}/report/balance`)

  return response.data
}